import { DeletePage } from '../crud/shared.js';

export class AuthDelete extends DeletePage {
  static get formAction() {
    return API.resourceUrl('authConfigs', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Authentication" href="/auth" nameHref="/auth/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Delete" suffixStyle="" suffixSeparatorStyle="">

    form.stacked-form[method="DELETE" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/auth"]
      p Please confirm deleting this item.
      .horizontal-flex.mt-15
        <FormButton label="Confirm Delete">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}"] Back
  `;

  static javascript() {
    API.get(API.resourceUrl('authConfigs', Routing.params.id))
      .then(data => {
        document.querySelector('#name').innerHTML = data.data.name;
      });
  }
}
